import styled from '@emotion/styled';

export const StyledParticipant = styled.div`
    grid-area: ${(props) => (props.isPinned ? 'pinned_participant' : '')};
    min-height: ${(props) =>
        props.isScreenShareActive
            ? props.isPinned
                ? '0'
                : '110px'
            : props.isPinned
              ? '280px'
              : props.isPinnedActive
                ? '180px'
                : '220px'};
    height: ${(props) => (props.isScreenShareActive && props.isPinned ? '100%' : 'auto')};

    @media (max-width: 800px) {
        width: 100%;
        min-height: ${(props) => (props.isPinned ? '280px' : props.isPinnedActive ? '170px' : '240px')};
        height: ${(props) =>
            props.isPinned ? 'min(46vh, 420px)' : props.isPinnedActive ? 'min(22vh, 220px)' : 'min(32vh, 320px)'};
    }
`;
